import { render, staticRenderFns } from "./AnchorButton.vue?vue&type=template&id=60c2a157&scoped=true"
import script from "./AnchorButton.vue?vue&type=script&lang=js"
export * from "./AnchorButton.vue?vue&type=script&lang=js"
import style0 from "./AnchorButton.vue?vue&type=style&index=0&id=60c2a157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2a157",
  null
  
)

export default component.exports